import produce from 'immer';
import { Actions } from './action';
import { AppActions } from './enum';
import { AppState } from './interface';
import {
    handleResetTariffsToPreAvc,
    handleInitStore,
    handleSetAvcResult,
    handleSetTariffs,
    setSelectedByID,
} from './util/reducer';
import { OverlayContent } from '../../enums/elementId';

export const initialState: AppState = {
    isLoading: false,
    address: undefined,
    error: undefined,
    selectedTariff: {
        tariffId: 'PRE-FIB-IP-1000',
        tariff: undefined,
    },
    tariffs: [],
    initialTariffs: [],
    avcResult: undefined,
    isOverlayLoaded: false,
    isOverlayOpen: false,
    activeOverlay: OverlayContent.FORM,
};

const appReducer = (state: AppState = initialState, action: Actions) =>
    produce(state, (draft) => {
        switch (action.type) {
            case AppActions.INIT_STORE:
                handleInitStore(draft, action.payload);
                break;
            case AppActions.SET_LOADING:
                draft.isLoading = action.loading;
                break;
            case AppActions.SET_ERROR:
                draft.error = action.error;
                draft.isLoading = false;
                break;
            case AppActions.SET_ADDRESS:
                draft.address = action.address;
                draft.isLoading = false;
                break;
            case AppActions.DELETE_ADDRESS:
                draft.address = undefined;
                draft.avcResult = undefined;
                draft.homesPassed = undefined;
                break;
            case AppActions.SET_TARIFFS:
                handleSetTariffs(draft, action.tariffs, action.isInit);
                break;
            case AppActions.SET_SELECTED_TARIFF_ID:
                setSelectedByID(draft, action.id);
                break;
            case AppActions.SET_AVC_RESULT:
                handleSetAvcResult(draft, action.result);
                break;
            case AppActions.SET_OVERLAY_LOADED:
                draft.isOverlayLoaded = true;
                break;
            case AppActions.OPEN_OVERLAY:
                draft.activeOverlay = action.overlayWrapper;
                draft.isOverlayOpen = true;
                break;
            case AppActions.CLOSE_OVERLAY:
                draft.isOverlayOpen = false;
                break;
            case AppActions.SET_ACTIVE_OVERLAY:
                draft.activeOverlay = action.activeOverlay;
                break;
            case AppActions.RESET_TARIFFS_TO_PRE_AVC:
                handleResetTariffsToPreAvc(draft);
                break;
            case AppActions.SET_HOMES_PASSED:
                draft.homesPassed = action.homesPassed;
                break;
        }
    });

export default appReducer;
